import { REQUESTS_FOR_PROPOSAL_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/requests_for_proposal_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['requestsForProposalIndex']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
